const adaptPhoneNumber = (phone) => (+phone.length !== 0 ? `+7${phone}` : '');

export default adaptPhoneNumber;
